import { render, staticRenderFns } from "./update-user-details-dialog.vue?vue&type=template&id=62dd420e&scoped=true&"
import script from "./update-user-details-dialog.vue?vue&type=script&lang=js&"
export * from "./update-user-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd420e",
  null
  
)

export default component.exports